<template>
  <div class="mod-user">
    <el-form
      :inline="true"
      :model="dataForm"
      @keyup.enter.native="initCartLIst()"
    >
      <el-form-item>
        <el-input
          v-model="dataForm.userName"
          placeholder="用户名/登录名"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="dataForm.phone"
          placeholder="手机号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="initCartLIst(1)">查询</el-button>
        <el-button
          v-if="isAuth('sys/user/save')"
          type="primary"
          @click="addOrUpdateHandle()"
          >新增</el-button
        >
        <el-button
          v-if="isAuth('sys/user/delete')"
          type="danger"
          @click="deleteHandle()"
          :disabled="dataListSelections.length <= 0"
          >批量删除
        </el-button>
        <!-- <el-button
          v-if="isAuth('sys/user/delete')"
          type="danger"
          @click="guanwang()"
          >查看普通用户
        </el-button>
        <el-button
          v-if="isAuth('sys/user/delete')"
          type="danger"
          @click="superY()"
          >超级管理员
        </el-button>
        <el-button
          v-if="isAuth('sys/user/delete')"
          type="danger"
          @click="epriseY()"
          >企业用户
        </el-button>
        <el-button
          v-if="isAuth('sys/user/delete')"
          type="danger"
          @click="lookY()"
          >监管用户
        </el-button> -->
        <!-- <el-button
          v-if="isAuth('sys/user/delete')"
          type="danger"
          @click="total()"
          >查看注册总人数
        </el-button> -->
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%"

    >
      <el-table-column type="index" width="50" label="#" align="center"> </el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="角色名：">
              <span>{{ props.row.rolesList }}</span>
            </el-form-item>
            <el-form-item label="所属企业：">
              <span>{{ props.row.enterpriseName }}</span>
            </el-form-item>
            <el-form-item label="所属部门：">
              <span>{{ props.row.departmentName }}</span>
            </el-form-item>
            <el-form-item label="所属职位：">
              <span>{{ props.row.jobName }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        header-align="center"
        align="center"
        label="用户名"
      >
      </el-table-column>
      <el-table-column
        prop="loginName"
        header-align="center"
        align="center"
        label="登录名"
      >
      </el-table-column>
      <!-- <el-table-column
        prop="email"
        header-align="center"
        align="center"
        label="邮箱"
      >
      </el-table-column>
      <el-table-column
        prop="phone"
        header-align="center"
        align="center"
        label="手机号"
      >
      </el-table-column> -->
      <el-table-column
        prop="status"
        header-align="center"
        align="center"
        label="状态"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" size="small" type="danger"
            >禁用</el-tag
          >
          <el-tag v-else size="small">正常</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        width="180"
        label="创建时间"
      >
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            v-if="isAuth('sys/user/update')"
            type="text"
            size="small"
            @click="addOrUpdateHandle(scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-if="isAuth('sys/user/delete')"
            type="text"
            size="small"
            @click="deleteHandle(scope.row.id)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total,prev, pager, next"
    >
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    ></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./user-add-or-update";

export default {
  data() {
    return {
      dataForm: {
        userName: "",
        phone:''
      },
      type:0,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      guanwangList:[],//官网注册人数
    };
  },
  components: {
    AddOrUpdate,
  },
  created() {
    // this.guanwang();
    // this.initCartLIst()
  },
  mounted() {
    // this.guanwang();
    this.initCartLIst()
  },
  methods: {
    // 获取数据列表
    initCartLIst(a) {
      a ? this.pageIndex = a : this.pageIndex 
      this.dataListLoading = true;
      this.$http({
        url: this.$http.adornUrl("/sys/user/listByOpenid"),
        method: "get",
        params: this.$http.adornParams({
          page: this.pageIndex,
          limit: this.pageSize,
          name: this.dataForm.userName,
          phone:this.dataForm.phone
        }),
      }).then(({ data }) => {
        console.log(data,'新闻');
        if (data && data.code === 0) {
          this.dataList = data.data.noOpenid.list;
          console.log(this.dataList);
          this.totalPage = data.data.noOpenid.totalCount;
          //this.guanwang()
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    //点击官网注册人数按钮的回调
    async guanwang(){
      // let {data} = await this.$ajaxGet('/sys/user/commonList')
      let {data} = await this.$ajaxGet('/sys/user/list')
      console.log(data,'官网注册人数')
      if (data && data.code === 0) {
         //data.data.list.forEach(element => {
            // console.log(element);
          //   if(element.userType === 3){
          //     this.dataList.push(element);
          //   }
          //   this.totalPage = this.dataList.length;
          // });
          console.log(this.dataList);
          this.dataList = data.data.list;
          this.totalPage = data.data.totalCount;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
    },
    //点击总注册人数按钮的回调
    async total(){
      this.getDataList()
    },
    // 获取数据列表
    // getDataList(a) {
    //   a ? this.pageIndex = a : this.pageIndex 
    //   this.dataListLoading = true;
    //   this.$http({
    //     url: this.$http.adornUrl("/sys/user/list"),
    //     method: "get",
    //     params: this.$http.adornParams({
    //       page: this.pageIndex,
    //       limit: this.pageSize,
    //       name: this.dataForm.userName,
    //     }),
    //   }).then(({ data }) => {
    //     if (data && data.code === 0) {
    //       this.dataList = data.data.list;
    //       console.log(this.dataList);
    //       this.totalPage = data.data.totalCount;
    //       //this.guanwang()
    //     } else {
    //       this.dataList = [];
    //       this.totalPage = 0;
    //     }
    //     this.dataListLoading = false;
    //   });
    // },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      // this.getDataList();
      this.initCartLIst()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      // this.getDataList();
      this.initCartLIst()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 删除
    deleteHandle(id) {
      var userIds = id
        ? [id]
        : this.dataListSelections.map((item) => {
          return item.id;
        });
      console.log(userIds);
      this.$confirm(
        `确定对[id=${userIds.join(",")}]进行[${id ? "删除" : "批量删除"}]操作?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$http({
            url: this.$http.adornUrl("/sys/user/delete"),
            method: "post",
            data: this.$http.adornData(userIds, false),
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.getDataList();
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
